var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"actions m-r-30 d-flex flex-column",class:{'is-in-dropdown m-t-15': _vm.isInDropdown}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }